export default __webpack_public_path__ + "static/media/advantagefireattack.d00455bd.png";